const dict = {
  chooseLang: "Elige idioma",

  // Licencia
  instructions: "Instrucciones",
  step1: "Paso 1: Escanea el código QR",
  locateqr: "Ubica el código QR a tu derecha.",
  useSmartphone:
    "Usa la cámara de tu smartphone o una aplicación de escaneo de códigos QR para escanearlo. Esto te llevará al siguiente paso.",
  step2: "Paso 2: Ingresa la información de la lista de reproducción",
  afterScan:
    "Después de escanear el código QR, se te pedirá que ingreses la información de tu lista de reproducción.",
  makeSure: "Asegúrate de completar todos los campos requeridos.",
  step3: "Paso 3: Regresa a la aplicación",
  onceYou:
    "Una vez que hayas ingresado los detalles de tu lista de reproducción, puedes regresar a la aplicación y continuar tu experiencia.",
  refresh: "ACTUALIZAR",
  playlist: "Lista de reproducción",
  bigPlaylist: "LISTAS DE REPRODUCCIÓN",
  noLicence: "No tienes una licencia.",
  scanLicence: "Escanea para comprar una licencia.",
  noPlaylist: "No tienes ninguna lista de reproducción",
  privacyBig: "MODO PRIVADO",
  scanToAddBig: "ESCANEAR PARA AÑADIR LISTA",
  scanToBuyBig: "ESCANEAR PARA COMPRAR LICENCIA",
  orVisit: "o visita",
  andenterdeviceID: "e ingresa este ID de dispositivo:",
  removePlaylist: "Eliminar lista de reproducción",
  wantToRemove: "¿Quieres eliminar?",
  cancelBig: "CANCELAR",

  // Inicio
  bigLiveTv: "TV EN VIVO",
  bigMovies: "PELÍCULAS",
  bigSeries: "SERIES",

  // Menú de canales
  noChannels: "Esta lista de reproducción no tiene datos de canales",
  searchChannels: "Buscar canal",
  tapToPlay: "Toca para reproducir el video.",
  categoryEmpty: "Esta categoría está vacía",

  // Películas
  noMovies: "Esta lista de reproducción no tiene datos de películas",
  searchMovies: "Buscar películas",

  // Series
  noSeries: "Esta lista de reproducción no tiene datos de series",
  searchSeries: "Buscar series",

  // Entidad
  play: "REPRODUCIR",
  recommendations: "Recomendaciones",

  // Información del usuario
  userInfo: "Información del usuario",
  aboutApp: "Acerca de la aplicación",

  // Cuenta de usuario
  account: "Cuenta",
  subscriptions: "Suscripciones",
  privacyPilicy: "Privacidad y política",
  languge: "Idioma",
  english: "Inglés",
  italian: "Italiano",
  german: "Alemán",
  spanish: "Español",
  french: "Francés",
  greek: "Griego",

  // Últimos detalles
  playInfo: "Información de la lista",
  playName: "Nombre de la lista:",
  host: "Servidor:",
  username: "Usuario:",
  password: "Contraseña:",
  packName: "Nombre del paquete:",
  expireDate: "Fecha de expiración:",

  // Política de privacidad
  one: "1. Descargo de responsabilidad sobre el contenido: Applay es una plataforma diseñada para mejorar tu experiencia digital. Sin embargo, es importante señalar que Applay no aloja, proporciona ni distribuye contenido de video. Nuestro servicio está diseñado para respaldar tu experiencia digital, pero no somos responsables de la disponibilidad, calidad o contenido del material de video, ya que esto está fuera de nuestro alcance.",
  two: "2. No nos hacemos responsables del contenido de terceros: Applay LLC no es responsable del contenido de terceros al que accedas a través de nuestra aplicación. Tu interacción con cualquier contenido externo, incluida su legalidad, fiabilidad o idoneidad, es bajo tu propio riesgo.",
  three:
    "3. Jurisdicción y cumplimiento: Applay LLC opera bajo la jurisdicción de los Estados Unidos. Los usuarios son responsables de asegurarse de que el uso de la aplicación cumpla con todas las leyes locales, estatales y federales.",
  four: "4. Política de precios: Los precios de los servicios de Applay están sujetos a cambios en cualquier momento sin previo aviso. Al aceptar este acuerdo, reconoces y aceptas que los precios pueden variar y que dichos cambios no afectarán tu servicio actual hasta la renovación de tu suscripción.",
  five: `5. Sin garantía: La aplicación Applay y sus servicios se proporcionan "tal cual", sin ninguna garantía expresa o implícita, incluidas, entre otras, las garantías implícitas de comerciabilidad, idoneidad para un propósito particular y no infracción.`,
  six: "6. Aceptación de términos: Al hacer clic en Aceptar, aceptas cumplir con los términos de este descargo de responsabilidad y reconoces que cualquier violación puede resultar en la terminación de tu acceso a los servicios de Applay.",
  orbixUserAgreement:
    "ACUERDO DE USUARIO Y DESCARGO DE RESPONSABILIDAD DE Applay",
  beforeyouProcc:
    "Antes de continuar, por favor lee y acepta los siguientes términos y condiciones:",

  // Política de privacidad de Evomedia
  evomediaTitle: "Política de Privacidad de Evo TV",
  evomediaSubtitle:
    "Por favor, lea la siguiente información sobre cómo se gestionan sus datos:",
  evomediaSection1Title: "1. Procesamiento y recopilación de datos técnicos",
  evomediaSection1Body1:
    "La aplicación evo tv está diseñada exclusivamente como una utilidad técnica para los clientes elegibles de Evomedia. La aplicación no incluye formularios de registro manual, creación de cuentas dentro de la app, ni recopila datos personales directos (como su nombre, número de teléfono o dirección de correo electrónico).",
  evomediaSection1Body2:
    "Sin embargo, para habilitar la transmisión de contenido multimedia y garantizar la seguridad del servicio, el sistema procesa la siguiente categoría de datos:",
  evomediaSection1Body3:
    "Identificadores del dispositivo: La dirección MAC del dispositivo o un ID de cliente interno se transmite de forma segura (mediante SSL/HTTPS) a nuestros servidores con el único propósito de validar, autenticar y autorizar el acceso a los canales de transmisión multimedia vinculados a su plan contratado.",
  evomediaSection1Body4:
    "Base legal y finalidad: El tratamiento de estos identificadores es estrictamente necesario para la ejecución de un contrato (la prestación del servicio de streaming solicitado) y para la seguridad y prevención del fraude (garantizando que solo los dispositivos autorizados accedan a los canales protegidos). Estos datos técnicos nunca se utilizan con fines de marketing, nunca se compartirán con terceros y no se utilizan para rastrear su historial de navegación general.",
  evomediaSection2Title: "2. Derechos del usuario (RGPD)",
  evomediaSection2Body1:
    "De acuerdo con el Reglamento General de Protección de Datos (RGPD), dado que los identificadores técnicos están vinculados a su cuenta de cliente, usted conserva el derecho de acceder, rectificar, restringir o solicitar la eliminación de los datos asociados a su dispositivo. Para ejercer estos derechos, contáctenos en suporte@evomedia.pt.",
  evomediaSection3Title: "3. Privacidad de los menores",
  evomediaSection3Body1:
    "No comercializamos directamente nuestros servicios a menores, ni recopilamos a sabiendas datos de menores de 13 años. El acceso a la aplicación es gestionado y autorizado por el titular de la cuenta (el cliente adulto).",
  evomediaSection4Title: "4. Cambios en esta política",
  evomediaSection4Body1:
    "Podemos actualizar nuestra Política de Privacidad de vez en cuando para reflejar mejoras técnicas o cambios normativos. Cualquier actualización entrará en vigor inmediatamente al publicarse en esta página.",
  evomediaSection5Title: "5. Contáctenos",
  evomediaSection5Body1:
    "Si tiene alguna pregunta sobre su privacidad o sobre la gestión técnica de la aplicación, contáctenos a través de:",
  evomediaSection5Body2: "Correo de soporte oficial: suporte@evomedia.pt",
  evomediaSection5Body3:
    "Correo de la cuenta de desarrollador: evomediamobile@gmail.com",

  //additional
  exitApp: "Salir de Applay",
  wantToExit: "¿Estás seguro de que quieres salir de Applay?",
  Resume: "Reanudar",

  whatsnewinv: "Qué hay de nuevo en v",
  whatsnew: "Qué hay de nuevo",
  instanthomescreen: "Navegación Mejorada del Menú de Canales",
  instanthomescreendesc:
    "Flujo de navegación mejorado y mejor experiencia de usuario en la selección de canales.",
  turbomoviesearch: "Información Completa de Configuración",
  turbomoviesearchdesc:
    "Configuraciones más detalladas y opciones de configuración reunidas en un solo lugar.",
  lighterondataandbattery: "Función de Reanudación Inteligente",
  lighterondataandbatterydesc:
    "Guarda y restaura automáticamente tu posición de reproducción sin interrupciones.",
  underthehoodfixes: "Correcciones Internas",
  underthehoodfixesdesc:
    "Mayor estabilidad del reproductor y confiabilidad en las operaciones de búsqueda.",
};

export default dict;
